import React from "react";
import { motion } from "framer-motion";

const projects = [
  {
    title: "Highway Corridor Upgrade",
    location: "Mpumalanga, RSA",
    image: "./images/services/civil.jpg",
    outcome: "Reduced commute time by 40%",
    scope: "Infrastructure & Civil Engineering",
    description:
      "Upgraded a major highway corridor to improve traffic flow and safety, incorporating sustainable design and intelligent transport systems.",
  },
  {
    title: "Smart Cold Chain Project",
    location: "Gauteng, RSA",
    image: "./images/services/civil.jpg",
    outcome: "Spoilage reduced by 75%",
    scope: "Specialized Logistics Infrastructure",
    description:
      "Implemented advanced cold chain logistics infrastructure to maintain product quality and reduce waste for FMCG clients.",
  },
];

const containerVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.3, duration: 0.8, ease: "easeOut" },
  }),
};

const imageHover = {
  hover: { scale: 1.05, transition: { duration: 0.3 } },
};

const ProjectCard = ({ project, index }) => {
  const isEven = index % 2 === 0;
  return (
    <motion.div
      className={`flex flex-col lg:flex-row ${
        isEven ? "" : "lg:flex-row-reverse"
      } items-center gap-10 my-16`}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      custom={index}
      variants={containerVariants}
    >
      <motion.div
        className="w-full lg:w-1/2 rounded-2xl overflow-hidden shadow-2xl border border-[#b8860b]"
        variants={imageHover}
        whileHover="hover"
      >
        <img
          src={project.image}
          alt={project.title}
          className="w-full h-[300px] object-cover rounded-2xl"
        />
      </motion.div>

      <motion.div
        className="w-full lg:w-1/2 space-y-4"
        variants={containerVariants}
        custom={index + 0.5}
      >
        <h3 className="text-3xl font-bold text-[#b8860b]">{project.title}</h3>
        <p className="text-sm text-gray-400 italic">{project.location}</p>
        <p className="text-gray-300 leading-relaxed">{project.description}</p>
        <div className="flex flex-wrap gap-4 mt-4">
          <span className="bg-white/10 border border-[#b8860b] text-[#b8860b] text-xs px-4 py-1 rounded-full">
            {project.scope}
          </span>
          <span className="text-green-300 text-sm">{project.outcome}</span>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default function Projects() {
  return (
    <section id="portfolio" className="bg-[#0f2027] py-24 px-6 md:px-16 text-white">
      <div className="max-w-7xl mx-auto">
        <motion.h2
          className="text-4xl md:text-5xl font-bold text-center text-[#b8860b] mb-20"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          Our Flagship Projects
        </motion.h2>

        {projects.map((project, index) => (
          <ProjectCard key={index} index={index} project={project} />
        ))}
      </div>
    </section>
  );
}
